import React, { Component } from "react";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";


class TooltipIconMfa extends Component {
  render() {


      return (
      <i
        className={`icon-info-blue-mfa ${this.props.customStyle}`}
        aria-label={this.props.ariaLabel}
        tabIndex="0"
        role="button"
        onClick={this.props.onToggle}
        onKeyPress={(e) => {
          handleKeyPress(e, this.props.onToggle);
        }}
      />
    );

    
    
  }
}

export default TooltipIconMfa;
